"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".dialogContent_54e64994{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.dialogLabel_54e64994{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.dialogInput_54e64994{min-width:250px;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;margin-left:10px}\n" }]);
exports.dialogContent = "dialogContent_54e64994";
exports.dialogLabel = "dialogLabel_54e64994";
exports.dialogInput = "dialogInput_54e64994";
//# sourceMappingURL=ConfirmDialog.scss.g.js.map